import { useQuery } from "react-apollo"
import { SATISFIES_DEPENDENCY_RANGE } from "../queries"

export function useSatisfiesDependencyRange({
  siteId,
  dependencyName,
  dependencyRange,
}: {
  siteId: string
  dependencyName: string
  dependencyRange: string
}) {
  const { loading, data, error } = useQuery(SATISFIES_DEPENDENCY_RANGE, {
    variables: { siteId, dependencyName, dependencyRange },
  })

  const satisfiesDependencyRange = data?.siteSatisfiesDependencyRange || false

  return { satisfiesDependencyRange, loading, error }
}
